import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss'

function Timeline() {
  return (
    <div id="history">
      <div className="items-container">
        <h1>IT Career History</h1>
        <VerticalTimeline>
          <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
              contentArrowStyle={{ borderRight: '7px solid  white' }}
              date="08/2025 - Present"
              iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
              icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Cloud/DevOps Engineer</h3>
            <h4 className="vertical-timeline-element-subtitle">Amsterdam, NL || Fortytwo Security B.V.</h4>
            <p>
              Cloud/DevOps Engineer. Contributing to many AWS environments, utilizing Terraform, Ansible, Packer and many more tools.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="02/2024 - 07/2025"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">DevOps & Full-Stack Software Engineer</h3>
            <h4 className="vertical-timeline-element-subtitle">Amsterdam, NL || Forward Football B.V.</h4>
            <p>
                DevOps and Full-Stack Web Development. Set up CI/CD pipelines with GitLab, Docker, and Terraform for automated AWS deployments, including code quality and security checks.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="02/2023 - 07/2023"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Intern Software Engineer</h3>
            <h4 className="vertical-timeline-element-subtitle">Amsterdam, NL || Maxem Energy Solutions B.V.</h4>
            <p>
              As an intern at Maxem I focused on Frontend Development and testing. However, I completed some Backend Development too. Furthermore, at this company I got introduced to AWS.
            </p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;